import React, { useContext, useState } from "react";
import { Icon, Switch, Table, Tag, Tooltip } from "antd";
import { ColumnProps } from "antd/lib/table/interface";
import styles from "./index.module.scss";
import { TableProps } from "antd/es/table";
import moment from "moment";
import { isTrue } from "service/service";
import style from "../../../../supervise/components/SuperviseTable/index.module.scss";
import {
    CatchPhoto,
    StudentAllRecordListItem,
    updateCatchPhoto,
    updatePaperDownload,
    updatePhoneUpload
} from "service/exam";
import { ButtonBan, ButtonMarkError } from "../../../components/ButtonsUtil";
import { ButtonUndoBan } from "../../../components/ButtonsUtil";
import useRequestFn from "utils/useRequestFn";
import ButtonDetail from "../../../components/ButtonsUtil/ButtonDetail";
import { ButtonUploadPage } from "../../../components/ButtonsUtil/ButtonUploadPage";
import StuTableColumn from "../../../../../../components/CourseComponents/StuTableColumn";
import { InvigilationCtx } from "../../../context";

interface InvigilationTableProps extends TableProps<any> {
    onChange: () => void;
}

export default function InvigilationTable({
    onChange,
    ...props
}: InvigilationTableProps) {
    const [uploading, setUploading] = useState(false);
    const { onSelect } = useContext(InvigilationCtx);

    const [onCatchPhotoChange, { loading: changeLoading }] = useRequestFn(
        async (
            checked: boolean,
            stuNo: string,
            examId: string,
            courseNo: string
        ) => {
            const status = checked ? CatchPhoto.open : CatchPhoto.close;
            await updateCatchPhoto(examId, status, stuNo);
            onChange();
        }
    );

    //手机端提交附件
    const [onUpdatePhoneChange, { loading: updateLoading }] = useRequestFn(
        async (
            checked: boolean,
            stuNo: string,
            examId: string,
            courseNo: string
        ) => {
            const status = checked ? CatchPhoto.open : CatchPhoto.close;
            await updatePhoneUpload(examId, status, stuNo);
            onChange();
        }
    );

    //下载试卷
    const [onUpdateDownChange, { loading: updateDownLoading }] = useRequestFn(
        async (
            checked: boolean,
            stuNo: string,
            examId: string,
            courseNo: string
        ) => {
            const status = checked ? CatchPhoto.open : CatchPhoto.close;
            await updatePaperDownload(examId, status, stuNo);
            onChange();
        }
    );

    const columns: ColumnProps<StudentAllRecordListItem>[] = [
        {
            title: "序号",
            dataIndex: "index",
            align: "center",
            render: (text, item, index) => index + 1
        },
        {
            title: "课程信息",
            render: (_, item) => (
                <div className={styles.student}>
                    {item.fullCourse.split(",").map((t, index) => (
                        <Tag style={{ marginTop: 3 }} key={t + index}>
                            {t}
                        </Tag>
                    ))}
                </div>
            )
        },
        {
            title: "考生信息",
            render: (val, item) => {
                return (
                    <div className={style.stuInfo}>
                        <StuTableColumn
                            name={item.studentName}
                            stuNo={item.studentNo}
                        />
                        {isTrue(item.ban) && (
                            <Tooltip title="该考生存在缺考、弃考或作弊行为、被老师强制“禁考”。">
                                <Icon type="user-add" />
                            </Tooltip>
                        )}
                        {/*{isTrue(item.ban) && (*/}
                        {/*    <Tooltip title="考试过程中存在异常行为，请点击“标记异常”查看。">*/}
                        {/*        <Icon type="warning" />*/}
                        {/*    </Tooltip>*/}
                        {/*)}*/}
                    </div>
                );
            }
        },
        {
            title: "打开试卷时间",
            dataIndex: "firstStartTime",
            align: "center",
            render: text => (
                <div>{text ? moment(text).format("MM-DD HH:mm") : "--"}</div>
            )
        },
        {
            title: "参与状态",
            dataIndex: "joinFlag",
            align: "center",
            render: text => <div>{isTrue(text) ? "已参与" : "未参与"}</div>
        },
        {
            title: "提交状态",
            dataIndex: "submitStatus",
            align: "center",
            render: text => <div>{text === "0" ? "未提交" : "已提交"}</div>
        },
        {
            title: "提交附件数",
            dataIndex: "uploadFileNum",
            align: "center",
            filters: [
                {
                    text: "提交附件数为0的",
                    value: "0"
                }
            ],
            onFilter: (value, record) => {
                return record.uploadFileNum.toString() === value.toString();
            },
            render: text => <div>{!text ? "0" : text}</div>
        },
        {
            title: "摄像头抓拍",
            dataIndex: "catchPhotoManual",
            align: "center",
            render: (text, item) => (
                <Switch
                    loading={changeLoading}
                    defaultChecked={isTrue(text)}
                    checked={isTrue(text)}
                    onChange={checked =>
                        onCatchPhotoChange(
                            checked,
                            item.studentNo,
                            String(item.examId),
                            item.courseNo
                        )
                    }
                />
            )
        },
        {
            title: "允许手机端提交附件",
            dataIndex: "allowPhoneUpload",
            align: "center",
            render: (text, item) => (
                <Switch
                    loading={updateLoading}
                    defaultChecked={isTrue(text)}
                    checked={isTrue(text)}
                    onChange={checked =>
                        onUpdatePhoneChange(
                            checked,
                            item.studentNo,
                            String(item.examId),
                            item.courseNo
                        )
                    }
                />
            )
        },
        {
            title: "是否允许下载试卷",
            dataIndex: "allowPaperDownload",
            align: "center",
            render: (text, item) => (
                <Switch
                    loading={updateDownLoading}
                    defaultChecked={isTrue(text)}
                    checked={isTrue(text)}
                    onChange={checked =>
                        onUpdateDownChange(
                            checked,
                            item.studentNo,
                            String(item.examId),
                            item.courseNo
                        )
                    }
                />
            )
        },
        {
            title: "操作",
            align: "center",
            render: (_, item) => {
                return (
                    <div className={style.operation}>
                        {!isTrue(item.ban) && (
                            <ButtonBan
                                examId={item.examId.toString()}
                                stuNo={item.studentNo}
                                onOk={onChange}
                            />
                        )}

                        {isTrue(item.ban) && (
                            <ButtonUndoBan
                                examId={item.examId.toString()}
                                stuNo={item.studentNo}
                                onOk={onChange}
                            />
                        )}

                        <ButtonUploadPage
                            stuNo={item.studentNo}
                            examId={item.examId.toString()}
                            onChangeUploadLoading={setUploading}
                        />

                        <ButtonMarkError
                            examId={item.examId.toString()}
                            stuNo={item.studentNo}
                            onChange={onChange}
                        />

                        <ButtonDetail
                            examId={item.examId.toString()}
                            stuNo={item.studentNo}
                            ban={item.ban as string}
                            onChange={onChange}
                        />
                    </div>
                );
            }
        }
    ];

    return (
        <Table
            className={styles.root}
            rowKey="studentNo"
            columns={columns}
            pagination={false}
            loading={props.loading || uploading}
            onRow={(record, index) => ({
                onClick: () => onSelect(index)
            })}
            {...props}
        />
    );
}
